import { Divider } from '@mui/material';
import { MemreButton, MemreFlexBox, MemreModal } from 'components/core';
import { useState } from 'react';
import { Regions } from 'services/useItem.service/interactions';
import { useAuthoringContext } from '../AuthoringContext';
import AttachInstructionalItem from '../components/AttachInstructionalItem';
import HotspotQuestion from '../components/HotspotQuestion';
import ImageUploadModal from '../components/ImageUpload/ImageUploadModal';

export default function RegionsElement() {
  const regions = useAuthoringContext()?.item as Regions;
  const [modalContent, setModalContent] = useState<JSX.Element | null>(null);

  const showAddImage = () =>
    setModalContent(<ImageUploadModal addImageMethod={regions.image.update} close={() => setModalContent(null)} />);

  return (
    <MemreFlexBox sx={{ p: 1, pr: 2, flex: 1 }}>
      <MemreFlexBox
        direction="column"
        justify="flex-start"
        align="center"
        sx={{ width: '100%', height: 'fit-content' }}
      >
        {regions.image.url && (
          <>
            {regions.hotspots.map((hotspot) => (
              <HotspotQuestion key={hotspot.id} hotspot={hotspot} url={regions.image.url} />
            ))}
            <MemreButton variant="text" text="Add Region" size="small" iconName="plus" onClick={regions.add} />

            <Divider sx={{ width: '100%', m: 0.5, mt: 2 }} />

            {regions?.id && <AttachInstructionalItem itemId={regions.id} />}
          </>
        )}
        {!regions.image.url && (
          <>
            <MemreButton variant="outlined" text="Add Image" onClick={showAddImage} />
            <MemreModal padding={0}>{modalContent}</MemreModal>
          </>
        )}
      </MemreFlexBox>
    </MemreFlexBox>
  );
}
